// Do not wrap these in a helper: @swc/plugin-loadable-components only rewrites literal
// `loadable(() => import('…'))` call sites, and SSR's ChunkExtractor needs that rewrite.
import loadable from '@loadable/component';

export { ReferencedComponentBlock } from '@components/block-content/types/components/ReferencedComponentSerializer/ReferencedComponentSerializer';
export { Shortcuts } from '@pages/FrontPage/components/Shortcuts/Shortcuts';
export { MainEntries } from '@pages/FrontPage/components/MainEntries/MainEntries';
export { MembershipBenefitHighlightListBlock } from './blocks/MembershipBenefitHighlightListBlock';
export { default as CustomBenefitListBlock } from './blocks/CustomBenefitListBlock/CustomBenefitListBlock';

export const Timeline = loadable(() => import('./blocks/Timeline/Timeline'));
export const ImageTitleAndLinkList = loadable(() => import('./blocks/ImageTitleAndLinkList'));
export const SecondaryEntriesBlock = loadable(() => import('./blocks/SecondaryEntriesBlock'));
export const StepByStepList = loadable(() => import('./blocks/StepByStepList'));

export const EmbeddedArticleBlock = loadable(() => import('./blocks/EmbeddedArticle/EmbeddedArticleBlock'), {
  resolveComponent: (m) => m.EmbeddedArticleBlock,
});

export const TravelSuggestions = loadable(() => import('./blocks/TravelSuggestions/TravelSuggestions'), {
  resolveComponent: (m) => m.TravelSuggestions,
});

export const TabBlock = loadable(() => import('./blocks/TabBlock'), { resolveComponent: (m) => m.TabBlock });

export const MembershipBenefitListBlock = loadable(() => import('./blocks/MembershipBenefitListBlock'), {
  resolveComponent: (m) => m.MembershipBenefitListBlock,
});

export const SingleNavigationCardBlock = loadable(() => import('./ColumnContent/SingleNavigationCardBlock'), {
  resolveComponent: (m) => m.SingleNavigationCardBlock,
});

export const VerticalArticleBlock = loadable(() => import('./ColumnContent/VerticalArticleBlock'), {
  resolveComponent: (m) => m.VerticalArticleBlock,
});

export const ColumnBlock = loadable(() => import('./ColumnBlock'), { resolveComponent: (m) => m.ColumnBlock });

export const FeaturedVehicleTestResult = loadable(() => import('./FeaturedVehicleTestResult'), {
  resolveComponent: (m) => m.FeaturedVehicleTestResult,
});

export const Results = loadable(() => import('./Testshowcase/Results/Results'), { resolveComponent: (m) => m.Results });

export const FeaturedBenefitBlock = loadable(
  () => import('./blocks/FeaturedBenefitBlocks/FeaturedBenefitBlock/FeaturedBenefitBlock'),
  { resolveComponent: (m) => m.FeaturedBenefitBlock },
);

export const IframeBlock = loadable(() => import('./blocks/IframeBlock'), { resolveComponent: (m) => m.IframeBlock });

export const InputWithImageLinkBlock = loadable(
  () => import('./blocks/InputWithImageLinkBlock/InputWithImageLinkBlock'),
  {
    resolveComponent: (m) => m.InputWithImageLinkBlock,
  },
);

export const ColorSection = loadable(() => import('@pages/TopicPageApp/ColorSection/ColorSection'), {
  resolveComponent: (m) => m.ColorSection,
});

export const PortraitsWithTextBlock = loadable(() => import('./blocks/PortraitsWithTextBlock'), {
  resolveComponent: (m) => m.PortraitsWithTextBlock,
});

export const MembershipBenefitsBlock = loadable(() => import('./blocks/MembershipBenefits'), {
  resolveComponent: (m) => m.MembershipBenefitsBlock,
});

export const CampaignBlock = loadable(() => import('./blocks/Campaign'), { resolveComponent: (m) => m.CampaignBlock });

export const TextAndImageBlock = loadable(() => import('./blocks/TextAndImageBlock'), {
  resolveComponent: (m) => m.TextAndImageBlock,
});

export const NewsBlock = loadable(() => import('./blocks/News/NewsBlock'), { resolveComponent: (m) => m.NewsBlock });

export const LatestArticlesBlock = loadable(() => import('./blocks/LatestArticleBlock'), {
  resolveComponent: (m) => m.LatestArticlesBlock,
});

export const HeroBlock = loadable(() => import('./blocks/HeroBlock'), { resolveComponent: (m) => m.HeroBlock });

export const CategoryListWithScrollBlock = loadable(() => import('./blocks/CategoryListWithScroll'), {
  resolveComponent: (m) => m.CategoryListWithScrollBlock,
});

export const ThreeColumnBlock = loadable(() => import('./blocks/ThreeColumnBlock'), {
  resolveComponent: (m) => m.ThreeColumnBlock,
});

export const AccordionBlock = loadable(() => import('./blocks/AccordionBlock'), {
  resolveComponent: (m) => m.AccordionBlock,
});

export const AccordionListBlock = loadable(() => import('./blocks/AccordionListBlock'), {
  resolveComponent: (m) => m.AccordionListBlock,
});

export const NewsfeedBlock = loadable(() => import('./blocks/NewsFeedBlock/NewsfeedBlock'), {
  resolveComponent: (m) => m.NewsfeedBlock,
});

export const ThemeHeroBlock = loadable(() => import('./blocks/ThemeHeroBlock/ThemeHeroBlock'), {
  resolveComponent: (m) => m.ThemeHeroBlock,
});

export const CountdownBlock = loadable(() => import('./blocks/CountdownBlock/CountdownBlock'), {
  resolveComponent: (m) => m.CountdownBlock,
});

export const QnaFeedBlock = loadable(() => import('./blocks/QnaFeedBlock'), {
  resolveComponent: (m) => m.QnaFeedBlock,
});

export const ScrollableTextBlocksWithBackgroundImages = loadable(
  () => import('./blocks/Parallax/ScrollableTextBlocksWithBackgroundImages'),
  { resolveComponent: (m) => m.ScrollableTextBlocksWithBackgroundImages },
);

export const ShowcaseBlock = loadable(() => import('./Testshowcase/ShowcaseBlock'), {
  resolveComponent: (m) => m.ShowcaseBlock,
});

export const LivestreamBlock = loadable(() => import('./blocks/LivestreamBlock'), {
  resolveComponent: (m) => m.LivestreamBlock,
});

export const ShortsCarouselBlock = loadable(() => import('./blocks/ShortsCarouselBlock'), {
  resolveComponent: (m) => m.ShortsCarouselBlock,
});

export const RouteCharts = loadable(() => import('./blocks/Charts/RouteCharts'), {
  resolveComponent: (m) => m.RouteCharts,
});

export const GoogleMapsWrapper = loadable(() => import('./blocks/Charts/GoogleMapsWrapper'), {
  resolveComponent: (m) => m.GoogleMapsWrapper,
});

export const TextBlock = loadable(() => import('./blocks/TextBlock'), { resolveComponent: (m) => m.TextBlock });

export const KeyStatisticsBlock = loadable(() => import('./blocks/KeyStatistics/KeyStatisticsBlock'), {
  resolveComponent: (m) => m.KeyStatisticsBlock,
});

export const MultiRowArticleBlock = loadable(() => import('./blocks/MultiRowArticleBlock'), {
  resolveComponent: (m) => m.MultiRowArticleBlock,
});

export const NavigationLinksBlock = loadable(() => import('./blocks/NavigationLinksBlock'), {
  resolveComponent: (m) => m.NavigationLinksBlock,
});

export const ImageLinksBlock = loadable(() => import('./blocks/ImageLinks/ImageLinksBlock'), {
  resolveComponent: (m) => m.ImageLinksBlock,
});

export const DocumentSnapshots = loadable(() => import('./blocks/DocumentSnapshots'), {
  resolveComponent: (m) => m.DocumentSnapshots,
});

export const BilguideSearchBlock = loadable(() => import('./blocks/BilguideSearchBlock'), {
  resolveComponent: (m) => m.BilguideSearchBlock,
});

export const FeaturedModelBlock = loadable(() => import('./FeaturedModelBlock/FeaturedModelBlock'), {
  resolveComponent: (m) => m.FeaturedModelBlock,
});

export const TwoArticleBlock = loadable(() => import('./blocks/TwoArticleBlock'), {
  resolveComponent: (m) => m.TwoArticleBlock,
});

export const TrialMembershipNavigationCardContainerBlock = loadable(
  () => import('./blocks/TrialMembership/welcomeCard/TrialMembershipNavigationCardContainerBlock'),
  { resolveComponent: (m) => m.TrialMembershipNavigationCardContainerBlock },
);

export const BodyCtaAndBodyBannerBlock = loadable(
  () => import('./blocks/TrialMembership/banner/BodyCtaAndBodyBannerBlock'),
  {
    resolveComponent: (m) => m.BodyCtaAndBodyBannerBlock,
  },
);

export const QRCodeBlock = loadable(() => import('./blocks/QRCode'), { resolveComponent: (m) => m.QRCodeBlock });

export const VippsLoginBlock = loadable(() => import('./blocks/VippsLogin'), {
  resolveComponent: (m) => m.VippsLoginBlock,
});

export const ProductsLoggedInActivationFormBlock = loadable(() => import('./blocks/ProductsLoggedInActivationForm'), {
  resolveComponent: (m) => m.ProductsLoggedInActivationForm,
});

export const TrialMembershipWelcomeCardBlock = loadable(
  () => import('./blocks/TrialMembership/welcomeCard/TrialMembershipWelcomeCardBlock'),
  { resolveComponent: (m) => m.TrialMembershipWelcomeCardBlock },
);

export const CardCarouselBlock = loadable(() => import('./blocks/TrialMembership/cardCarousel/CardCarouselBlock'), {
  resolveComponent: (m) => m.CardCarouselBlock,
});

export const CompareMembershipBlock = loadable(() => import('./blocks/CompareMembershipBlock/CompareMembershipBlock'), {
  resolveComponent: (m) => m.CompareMembershipBlock,
});

export const ConsumerGuidesBlock = loadable(() => import('./blocks/ConsumerGuideBlock/ConsumerGuideBlock'), {
  resolveComponent: (m) => m.ConsumerGuideBlock,
});

export const ModularButtonBlock = loadable(() => import('./blocks/ModularButtonBlock'), {
  resolveComponent: (m) => m.ModularButtonBlock,
});

export const ConsumerTestProductList = loadable(
  () => import('@components/block-content/types/components/ConsumerTestProductList/ConsumerTestProductList'),
  { resolveComponent: (m) => m.ConsumerTestProductList },
);

export const FAQGlobalReferenceBlock = loadable(
  () => import('./blocks/FAQGlobalReferenceBlock/FAQGlobalReferenceBlock'),
  {
    resolveComponent: (m) => m.FAQGlobalReferenceBlock,
  },
);

export const OtherInformationBlock = loadable(() => import('./blocks/OtherInformationBlock'), {
  resolveComponent: (m) => m.OtherInformationBlock,
});

export const NafLocationsMapBlock = loadable(() => import('./blocks/NafLocationsMapBlock/NafLocationsMapBlock'), {
  resolveComponent: (m) => m.NafLocationsMapBlock,
});

export const ProductCardListBlock = loadable(() => import('./blocks/ProductCardListBlock'), {
  resolveComponent: (m) => m.ProductCardListBlock,
});
